<template>
    <div v-if="vipRewardTradeStatus==1">
      <van-nav-bar
        title="VIP奖励 交易奖励"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/members')"
        right-text="账单"
        @click-right="$router.push('/member/vip_reward_details')"
      />
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="backgroud">
          <van-row >
            <van-col span="12">
              <div class="capital" style="margin-left: -40px; margin-top: 10px;">
                <h5>可转出余额</h5>
                <p>{{ user_vip_reward_balance }}元</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="capital" style="margin-right: -40px;margin-top: 10px;">
                <h5>累积奖励</h5>
                <p>{{ user_cumulative_vip_reward }}元</p>
              </div>
            </van-col>
          </van-row>
          <div class="capital-btn">
            <van-row style="margin-bottom: 3px;">
              <van-col span="8"></van-col>
              <van-col span="8">
                <van-button
                  class="button-out"
                  type="info"
                  size="normal"
                  @click="vipRewardTransferState = true; vipRewardAmount = user_vip_reward_balance;"
                  style="height: 30px; width: 100px"
                  >转出</van-button
                >
              </van-col>
              <van-col span="8"></van-col>
            </van-row>
          </div>
          <br>
        </div>
        
        <!-- <van-divider /> -->
        <p  v-html="vipRewardDesc" style="padding-right: 10px; padding-left: 10px; padding-bottom: 20px; text-align: justify;"></p>
      </van-pull-refresh>
  
      <!-- ==================== vip reward transfer popup ========================== -->
  
      <van-dialog
        v-model="vipRewardTransferState"
        title="VIP奖励转出"
        show-cancel-button
        :beforeClose="vipRewardTransfer"
      >
        <van-row>
          <van-col span="6">
            <p style="padding-left: 15px; font-size: 14px">可转余额:</p>
          </van-col>
          <van-col span="12"
            ><p style="padding-left: 30px; font-size: 14px">
              {{ user_vip_reward_balance }}元
            </p></van-col
          >
        </van-row>
        <van-cell-group>
          <van-field
            type="number"
            v-model="vipRewardAmount"
            label="转出金额:"
            placeholder=""
            @input="validateInput"
          />
        </van-cell-group>
      </van-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "VipReward",
    data() {
      return {
        isLoading: false,
        user_vip_reward_balance: 0,
        user_cumulative_vip_reward: 0,
        vipRewardAmount: 0,
        vipRewardTransferState: false,
        vipRewardDesc:'',
        vipRewardTradeStatus: 0
      };
    },
    computed: {},
    methods: {
      isLogin() {
        let that = this;
        if (!that.$store.state.loginType) {
          that.$router.push("/login");
        }
      },
      mainMethod() {
        this.getUserinfo();
      },
      onRefresh() {
        this.mainMethod();
        this.isLoading = false;
      },
      getUserinfo() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.user_vip_reward_balance = res.data.data.user_vip_reward_balance;
              that.user_cumulative_vip_reward = res.data.data.user_cumulative_vip_reward;
              that.vipRewardDesc = res.data.data.vip_reward_desc;
              that.vipRewardTradeStatus = res.data.data.vipRewardTradeStatus;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      validateInput (value) {
        // Allow only numbers with up to 2 decimal places
        if (value.startsWith('.')) value = '0' + value; 
        this.vipRewardAmount = value.replace(/[^0-9.]/g, '')           
                  .replace(/(\..*?)\..*/g, '$1')     
                  .replace(/^(\d+\.?\d{0,2}).*/, '$1');
        
      },
      vipRewardTransfer(action, done) {
        let that = this;
        switch (action) {
          case "confirm":
            let money = that.vipRewardAmount;
            if (money == "" || money <= 0 || isNaN(money)) {
              this.$toast({
                type: "warning",
                message: "请输入正确金额",
              });
              done(false);
            } else {
              that
                .$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "vip_reward",
                    token: sessionStorage.getItem("token"),
                    action: "vip_reward_withdraw",
                    amount: money,
                  },
                })
                .then(function (res) {
                  if (res.data.code == 1) {
                    that.$toast({
                      message: res.data.msg,
                      type: "success",
                      onClose: function () {
                        that.mainMethod();
                        that.vipRewardAmount = 0;
                        done();
                      },
                    });
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(res.data.msg);
                    done(false);
                  }
                });
            }
            break;
          case "cancel":
            done();
            break;
        }
      },
    },
    mounted() {
      this.getUserinfo();
    },
  };
  </script>
  
  <style scoped>
  .capital {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .capital h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    color: #000000;
  }
  
  .capital p {
    margin: 0;
    color: #D02E27;
    font-size: 14px;
    font-weight: bold;
  }
  
  .capital-btn {
    margin-top: 10px;
    text-align: center;
    
  }
  .button-out{
    border-radius: 6px !important;
    background-color: #0D268D !important;
    border: 1px solid #0D268D !important;
  }
  .backgroud {
    margin:10px 10px 5px 10px !important;
    border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
    overflow: hidden;
  }
  .description{
    padding: 20px;
    margin-top: -10px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/VipReward.vue